import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import Avatar from "@material-ui/core/Avatar";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteServiceAreas = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const columns = "2"; // 1 / 2
	const header = `Proudly Serving the Austin Area Since 1954`;
	const subHeader = ``;
	const tagline = "";
	const textAlign = "left";
	const lineBreak = false;
	const content =
		"Our top-rated lawn care and landscaping services are available to commercial and residential properties in Macomb, Shelby, Chesterfield, and other nearby areas in Michigan.";

	const button = "Get a free estimate";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary";
	const buttonSecondaryLink = "/wesbite/about-us";

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={10}
							direction={textAlign === "left" ? "row" : "row-reverse"}
						>
							<Grid item xs={12} sm={12} md={columns === "1" ? 12 : 6}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									height={"100%"}
									m={
										textAlign === "left"
											? { xs: 0, sm: "0px 40px 0px 0px" }
											: { xs: 0, sm: "0px 0px 0px 40px" }
									}
								>
									{tagline && <div className="tagline">{tagline}</div>}

									<h2>{header ? header : "Areas we serve"}</h2>
									{subHeader && <h3>{subHeader}</h3>}
									{lineBreak && (
										<Box my={1}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}
									{content && (
										<>
											<p>{content}</p>
										</>
									)}

									{(button || buttonSecondary) && (
										<div className={classes.columnButtonsBox}>
											{button && (
												<Button
													size="large"
													color="primary"
													variant="contained"
													disableElevation
													href={buttonLink}
													className="columnButton"
												>
													{button}
												</Button>
											)}

											{buttonSecondary && (
												<Button
													size="large"
													color="secondary"
													variant="outlined"
													disableElevation
													href={buttonSecondaryLink}
													className="columnButton"
												>
													{buttonSecondary}
												</Button>
											)}
										</div>
									)}
								</Box>
							</Grid>

							<Grid item xs={12} sm={12} md={columns === "1" ? 12 : 6}>
								<Box
									width={"100%"}
									height={"100%"}
									display={"inline-block"}
									borderRadius={4}
								>
									<Box
										component={"img"}
										//minHeight={"70vh"}
										className="picture"
										src="https://api.mapbox.com/styles/v1/mattydyer/cltpzx1v200ah01qwe36zhw6c/static/pin-l+0D1619(-97.73884582519531,30.322032928466797)/-97.73884582519531,30.322032928466797,13,0/800x800@2x?access_token=pk.eyJ1IjoibWF0dHlkeWVyIiwiYSI6ImNsZGoxNGU2eTA0M24zb2t3ZXZvYWRod24ifQ.GYW7sqkNhyIqGKmaqDE5sQ"
										//replace with the map we use with the outlines / radius around city
									/>
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteServiceAreas;
